var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_BATCH_ORDERS_COUNT_REQUEST, fetchBatchOrdersCountFailure, fetchBatchOrdersCountSuccess, } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onFetchGetBatchOrderCount = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/cnvt/batch/shipment/count`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchGetBatchOrderCountWorker(action) {
    try {
        const data = yield call(onFetchGetBatchOrderCount, action);
        yield put(fetchBatchOrdersCountSuccess(data));
    }
    catch (error) {
        yield put(fetchBatchOrdersCountFailure(error));
    }
}
export function* watchGetBatchOrderCountData() {
    yield takeLatest(FETCH_BATCH_ORDERS_COUNT_REQUEST, fetchGetBatchOrderCountWorker);
}
